/*
 * A barra de compartilhamento — o `ShareMediasSection` do Next, e o gêmeo React do
 * `article_template/share_medias.php` que a interpretação ainda usa.
 *
 * As CINCO redes saem sempre, iguais nos dois breakpoints. A régua de cima não está aqui: é o
 * `::before` de `.content-page__share`.
 *
 * Os `href` chegam prontos do PHP: o do Whatsapp e o do X levam o TÍTULO do artigo, que é
 * texto de CMS — montá-los aqui exigiria trazer o título para o cliente só para reencodá-lo.
 * O TikTok é o único que não compartilha nada: aponta para o perfil da Astrolink, como no Next.
 */
import React from 'react';

import { IShareHrefs } from '../types';

import SHARE_ICONS, { TShareNetwork } from './ShareIcons';


/** A ordem da barra, e a mesma da grade de cinco colunas do CSS. */
const NETWORKS: Array<{ key: TShareNetwork, name: string }> = [
    { key: 'whatsapp', name: 'Whatsapp' },
    { key: 'x', name: 'X' },
    { key: 'facebook', name: 'Facebook' },
    { key: 'messenger', name: 'Messenger' },
    { key: 'tiktok', name: 'TikTok' }
];

interface IShareBarProps {
    /** Rótulo da barra ("Compartilhar"), já traduzido. */
    label: string;
    hrefs: IShareHrefs;
}

const ShareBar: React.FC<IShareBarProps> = ({ label, hrefs }) => (
    <nav className="content-share" aria-label={label}>
        <p className="content-share__label">{label}</p>

        {NETWORKS.map(({ key, name }) => {
            const Icon = SHARE_ICONS[key];

            return (
                <a
                    key={key}
                    className="content-share__link"
                    href={hrefs[key]}
                    rel="nofollow noopener noreferrer"
                    target="_blank"
                    title={name}
                    aria-label={name}
                >
                    <i className="content-share__icon" aria-hidden="true"><Icon /></i>

                    <span className="content-share__name">{name}</span>
                </a>
            );
        })}
    </nav>
);

export default ShareBar;
